<template>
  <div
    v-if="show"
    class="el-loading-mask myloading is-fullscreen"
    style="z-index: 2003;"
  >
    <div class="loading-center">
      <div class="loading-modal">
        <el-image
          v-if="sucesso"
          :class="{'loading-modal-image-stop': sucesso}"
          :src="successIconUrl"
          class="loading-modal-image"
        />
        <div
          v-else
          class="loading-modal-spinner"
        />
        <p
          :class="{'loading-modal-text-success-color': sucesso}"
          class="loading-modal-text"
        >
          {{ texto }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { successIcon } from '@/utils/ImageBucket'

export default {
  name: 'LoadingModal',
  props: {
    sucesso: {
      type: Boolean,
      default: true
    },
    texto: {
      type: String,
      default: 'Validando código'
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    successIconUrl () {
      return successIcon()
    }
  }
}
</script>

<style scoped>
.loading-modal-background {
}

.loading-center {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
}

.loading-modal {
  min-width: 315px;
  background: #FFFFFF;
  box-shadow: 0 2px 10px #0000000D;
  border-radius: 20px;
  padding: 20px 15px;
  height: fit-content;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.loading-modal-image {
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
}

.loading-modal-spinner {
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
  border: 8px solid #0052ec;
  border-top-color: rgba(0, 82, 236, 0.25);
  border-radius: 50%;
  position: relative;
  animation: loader-rotate 1s linear infinite;
}

@keyframes loader-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loading-modal-image-stop {
  animation: none !important;
}

.loading-modal-text {
}

/*noinspection ALL*/
.loading-modal-text-success-color {
  color: #5BCE5B;
}
</style>
